import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import HeaderSection from '../comp/HeaderSection';
import ChartsSection from './ChartsSection';
import ChartsSection2 from './ChartsSection2';
import ChartsSection3 from './ChartsSection3';

import { getResumoFinanceiro, getKpiVendas, getCampeaoVendas, getAnyRoute } from '../../../api';

const PageContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Adjust as needed for responsiveness */
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Vendas = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [kpis, setKpis] = useState({});
  const [campeaoVendas, setCampeaoVendas] = useState(null);
  const [metasVendas, setMetasVendas] = useState([]);

  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });

  // Guarda qual é o filtro mais recente — se a resposta de uma busca antiga
  // chegar depois de uma mais nova (fora de ordem), ela é descartada em vez
  // de sobrescrever o resultado correto na tela.
  const filtroRef = useRef(filtro);

  useEffect(() => {
    filtroRef.current = filtro;
    fetchData(filtro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  const fetchData = async (filtroDaBusca) => {
    try {
      const result = await getResumoFinanceiro();
      const result2 = await getKpiVendas(filtroDaBusca);
      const result3 = await getCampeaoVendas(filtroDaBusca);
      const result4 = await getAnyRoute('metasvendarecebimento', filtroDaBusca);

      // Enquanto essa busca estava em andamento, o filtro já mudou de novo —
      // descarta essa resposta, pois já tem uma busca mais recente em curso.
      if (filtroDaBusca !== filtroRef.current) return;

      setData(result);
      setKpis(result2);
      setCampeaoVendas(result3);
      setMetasVendas(result4);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      if (filtroDaBusca === filtroRef.current) setLoading(false);
    }
  };

  if (loading) {
    return <p>Carregando gráfico...</p>;
  }

  return (
    <PageContainer>
      <HeaderSection title={'Vendas'} setFiltro={setFiltro} filtro={filtro} />
      <ChartsSection data={data} />
      <ChartsSection2 kpis={kpis} data={metasVendas} filtro={filtro} />
      <ChartsSection3 campeaoVendas={campeaoVendas} />
    </PageContainer>
  );
};

export default Vendas;